import api from "../../../utilidades/interceptor";
import axios from "axios";
const urlApi = process.env.REACT_APP_API_KEY
const wialon = process.env.REACT_APP_WIALON_KEY



export const getProveedoresTaller = async () => {
    try {
        const result = await api.get(`${urlApi}/maintenance/proveedores-taller`);
        return result.data;
    } catch (error) {
        console.log('error', error);
    }
};


export const addProveedorTaller = async (data) => {
    try {
        const result = await api.post(`${urlApi}/maintenance/proveedores-taller`, data);
        return result.data.id;
    } catch (error) {
        console.log('error', error);
    }
};

export const updateProveedorTaller = async (id, data) => {
    try {
        const result = await api.put(`${urlApi}/maintenance/proveedores-taller/${id}`, data);
        return result.data;
    } catch (error) {
        console.log('error', error);
    }
};

export const getGeofencesTaller = async () => {
    try {
        const result = await axios.get(`${wialon}/taller`);
        return result.data;
    } catch (error) {
        console.log('error', error);
    }
};

export const updateGeofence = async (geocercaPayload) => {
    try {
        console.log('geocercaPayload', geocercaPayload);
        const result = await axios.put(`${wialon}/upsertGeofence`, { geocercaPayload });
        return result.data;
    } catch (error) {
        console.log('error', error);
    }
}

export const deleteProveedorTaller = async (id) => {
    try {
        const result = await api.delete(`${urlApi}/maintenance/proveedores-taller/${id}`);
        return result.data;
    } catch (error) {
        console.log('error', error);
        throw error;
    }
};

export const getEstados = async () => {
    try {
        const result = await api.get(`${urlApi}/maintenance/catalogos/estados`);
        return result.data;
    } catch (error) {
        console.log('error', error);
    }
};

export const getCiudadesPorEstado = async (idEstado) => {
    try {
        const result = await api.get(`${urlApi}/maintenance/catalogos/ciudades/${idEstado}`);
        return result.data;
    } catch (error) {
        console.log('error', error);
    }
};


export const getProveedoresOdoo = async () => {
    try {
        const result = await api.get(`${urlApi}/maintenance/catalogos/proveedores`);
        return result.data;
    } catch (error) {
        console.log('error', error);
    }
};
